module.exports = __webpack_public_path__ + "static/img/Derge-Parkhang-1.ea52fac.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/DergeParkhang/Derge-Parkhang-1.jpg
// module id = FR5b
// module chunks = 3